/*
 * JARS Preise im Browser (09.10.2026, Block Streichpreise und Black Friday, Plan 6.2).
 * Dieselben Regeln wie snippets/jars-preis-werte.liquid, für Preise, die erst im Browser entstehen:
 * Schnellansicht der Filterkarten (assets/jars-filter.js), mitlaufender Warenkorb-Knopf (sections/jars-sticky-warenkorb.liquid),
 * Suchvorschläge im Kopf (sections/jars-header-skript.liquid).
 *   - Der Vergleichspreis der Produktdaten wird nie gelesen; außerhalb einer Aktion kein Streichpreis.
 *   - Aktion nur mit window.JarsAktion (gibt jars-aktion-kopf nur aus, wenn die Aktion eingeschaltet ist) und einem Tag aus der Zuordnung.
 *   - Rabatt zuerst kaufmännisch auf Cent runden, dann Preis minus Rabatt; Prozent abgerundet; keine Ermäßigungsangabe ohne Abstand.
 *   - Beide Zustände stehen im HTML, sichtbar ist der passende über die Klasse jars-aktion-an am html-Element.
 * Keine B-Ware-Zeile im Browser (nur serverseitig).
 */
(function () {
  'use strict';
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  function aktion() { return window.JarsAktion || null; }
  function aktiv() { return document.documentElement.classList.contains('jars-aktion-an'); }
  function tagListe(tags) {
    if (Array.isArray(tags)) return tags;
    return String(tags || '').split(',');
  }
  // Rabattstufe aus den Tags, höchste Stufe gewinnt; ohne Aktion 0
  function stufe(tags) {
    var a = aktion();
    if (!a || !a.zuordnung) return 0;
    var s = 0;
    tagListe(tags).forEach(function (t) {
      var p = a.zuordnung[String(t).trim().toLowerCase()];
      if (p > s && p < 100) s = p;
    });
    return s;
  }
  // preis in Cent; variantenId darf fehlen (Suchvorschläge), dann ohne Ausnahmen
  function werte(tags, variantenId, preis) {
    preis = Math.round(Number(preis)) || 0;
    var w = { aktion: false, stufe: 0, preis: preis, aktionspreis: preis, referenz: preis, prozent: 0 };
    var s = stufe(tags);
    if (!s) return w;
    var a = aktion();
    w.aktion = true;
    w.stufe = s;
    w.aktionspreis = preis - Math.floor((preis * s + 50) / 100);
    var ausnahme = variantenId != null && a.ausnahmen ? a.ausnahmen[String(variantenId)] : undefined;
    if (ausnahme > 0) w.referenz = ausnahme;
    if (w.aktionspreis < w.referenz) w.prozent = Math.floor(((w.referenz - w.aktionspreis) * 100) / w.referenz);
    return w;
  }
  // stil: 'gfqv' (Schnellansicht, volle Angabe), 'sticky' und 'vorschlag' (kompakt: im Aktionszustand nur der Aktionspreis,
  // ohne Ermäßigungsangabe). fmt bekommt Cent und liefert den Text im Format der jeweiligen Stelle.
  function html(w, stil, fmt, vorsatz) {
    var v = vorsatz || '';
    var f = function (c) { return esc(v + fmt(c)); };
    var tief = '';
    if (w.aktion && w.prozent > 0) {
      var text = (aktion() && aktion().texte && aktion().texte.tief) || 'Niedrigster Preis der letzten 30 Tage:';
      tief = '<span class="jars-preis__tief jars-preis__aktion">' + esc(text) + ' ' + esc(fmt(w.referenz)) + '</span>';
    }
    if (stil === 'gfqv') {
      if (!w.aktion) return '<span class="gfqv-product-card__price money">' + f(w.preis) + '</span>';
      return '<span class="gfqv-product-card__price money jars-preis__ohne-aktion">' + f(w.preis) + '</span>' +
        (w.prozent > 0
          ? '<span class="jars-preis__aktion"><span class="gfqv-product-card__oldprice money">' + f(w.referenz) + '</span> <span class="gfqv-product-card__saleprice money">' + f(w.aktionspreis) + '</span></span>' + tief
          : '<span class="gfqv-product-card__price money jars-preis__aktion">' + f(w.aktionspreis) + '</span>');
    }
    if (!w.aktion) return f(w.preis);
    return '<span class="jars-preis__ohne-aktion">' + f(w.preis) + '</span><span class="jars-preis__aktion">' + f(w.aktionspreis) + '</span>';
  }
  window.JarsPreis = { werte: werte, html: html, aktiv: aktiv, stufe: stufe };
})();
